export const accessibilityComponentsMap: Record<string, () => Promise<any>> = {
  ecomotive: () => import('./AccessibilityEcomotive.vue'),
};